import React from 'react';
import type ReactType from 'react';
import * as S from './styled';
import cls from 'classnames';

export interface Props {
  centerTitle?: boolean;
  newStyle?: boolean;
  stickyFooter?: boolean;
  className?: string;
  id?: string;
}

const ModalTitle: ReactType.FC<Props> = ({
  children,
  centerTitle,
  className,
  stickyFooter,
  newStyle,
  id,
}) => {
  return (
    <S.ModalTitle
      $centerTitle={centerTitle}
      $newStyle={newStyle}
      $stickyFooter={stickyFooter}
      className={cls('ModalTitle', className)}
      id={id}
    >
      {children}
    </S.ModalTitle>
  );
};

export default ModalTitle;
